import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Card, CardMedia, CardHeader, CardContent, Typography, Button, Dialog } from '@material-ui/core'
import noPhoto from '../../../assets/images/resim-yok.png'
function AnnouncementCard({item}) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Card className="m-2" key={item.id}>
   { ( item.imageUrl !== null) && <CardMedia  
    component="img"
    alt="Contemplative Reptile"
    height="140"
    image={item.imageUrl === "" ? noPhoto : item.imageUrl}
    title="Contemplative Reptile"
    style={{ objectFit: 'cover', objectPosition: 'top', width: '100%' }}
  />}
  <CardHeader
  title={item.title}
  subheader={new Date(item.createDate).toLocaleString()}
  />
    <CardContent>
      <Typography variant="body2" color="textSecondary" component="p">
        {item.body}
      </Typography>
      {(item.imageUrl && item.imageUrl !== "") && (
        <Button variant="outlined" color="primary" onClick={handleOpen} style={{marginTop: 8}}>
          Detay
        </Button>
      )}
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <div style={{ position: 'relative', padding: 24, textAlign: 'center' }}>
          <Button 
            onClick={handleClose} 
            variant="contained" 
            color="secondary" 
            style={{position: 'absolute', top: 16, right: 16, zIndex: 2, fontWeight: 'bold', fontSize: 18, padding: '8px 24px'}}
          >
            Kapat
          </Button>
          <img
            src={item.imageUrl}
            alt="Duyuru Görseli"
            style={{ width: '100%', height: 'auto', maxHeight: '60vh', objectFit: 'contain', background: '#000', marginBottom: 24 }}
          />
          <Typography variant="body1" style={{ color: '#fff', background: 'rgba(0,0,0,0.7)', padding: 16, borderRadius: 8, display: 'inline-block', maxWidth: '100%' }}>
            {item.body}
          </Typography>
        </div>
      </Dialog>
    </CardContent>
    </Card>
  )
}

AnnouncementCard.propTypes = {}

export default AnnouncementCard
